import React from "react";
import { useQuery } from "seed/gql";

const useNotifications = ({
  flow,
  isDebug = false,
}) => {

  const userId = sessionStorage.getItem("id");

  let flowFilter;
  const awaitingCondition = `status=AWAITING AND is_debug=${isDebug}`;
  const unreadAsyncCondition = `chat_message.chat.is_read=false AND chat_message.chat.is_async=true AND chat_message.chat.is_debug=${isDebug}`;

  if (flow)
    flowFilter = `flow.id=${flow.id}`;
  else
    flowFilter = `(flow.is_temp=false AND flow.is_current_version=True AND flow.is_active=true) AND ` +
      `(flow.user.id=${userId} OR (flow.participants.user.id=${userId} AND flow.participants.is_rejected=false))`;

  const queryFilter = `((${flowFilter} AND ${awaitingCondition}) OR (${flowFilter} AND ${unreadAsyncCondition}))`;

  const reqExecutions = useQuery(`{
    executions {
      updatedAt
      isRead
      status
      parent {}
      firstStep {
        flowNode {
          id
          rootName
        }
      }
      chatMessage {
        chat {
          isAsync
          isRead
          settings
        }
      }
    }
  }`,
    queryFilter,
    {
      orderBy: "-updated_at"
    });

  const refetchNotifications = () =>
    reqExecutions.refetch();

  const { executions = [] } = reqExecutions.data || {};
  const { notifications = [] } = executions.reduce((acc, execution) => {

    const { parent, status, firstStep } = execution;

    if (!firstStep) return acc;
    if (parent) return acc;

    if (status == "AWAITING")
      acc.notifications.push({ amount: 1, isAwaiting: true, execution });

    // if (status == "OK" || status == "FAILED") {

    //   const flowNodeId = firstStep.flowNode.id;
    //   const existing = acc.used[flowNodeId];

    //   if (existing) {
    //     const { index } = existing;
    //     acc.notifications[index].amount += 1;
    //     acc.notifications[index].group.push(execution);
    //   }
    //   else {
    //     acc.notifications.push({ amount: 1, isAsync: true, execution, group: [execution] });
    //     acc.used[flowNodeId] = { index: acc.notifications.length - 1 };
    //   }

    // }

    return acc;

  }, {
    used: {},
    notifications: []
  });

  return {
    notifications,
    refetchNotifications,
  }

}

const NotificationCount = ({ flow, isDebug, right, top, fontSize }) => {
  const { notifications } = useNotifications({ flow, isDebug });
  return <>
    {
      notifications.length > 0 &&
      <span className="badge badge-danger position-absolute"
        style={{ right, top, fontSize }}>
        {notifications.length}
      </span>
    }
  </>
}

export {
  NotificationCount,
  useNotifications
}